/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { UploadsModule } from "@progress/kendo-angular-upload";
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, ErrorHandler } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { CoreModule } from './@core/core.module';
import { ThemeModule } from './@theme/theme.module';
import { AppComponent } from './app.component';
import { AppRoutingModule ,routes} from './app-routing.module';
//import { ProductsService } from './main/routemaster/addroutemaster/enroutestops/products.service';
//import { ProductsService2 } from './main/roadmaster/addroadmaster/roadstops/products.service';
import {
  NbChatModule,
  NbDatepickerModule,
  NbDialogModule,
  NbMenuModule,
  NbSidebarModule,
  NbToastrModule,
  NbWindowModule,
} from '@nebular/theme';


import { FormsModule } from '@angular/forms';
// import { CalendarModule } from 'primeng/calendar';
import { DropdownModule } from 'primeng/dropdown';
import { RadioButtonModule } from 'primeng/radiobutton';

import { ErrorInterceptor } from '../app/helpers/error.interceptor';
import { SuccessInterceptor } from '../app/helpers/success.interceptor';
import { JwtInterceptor } from '../app/helpers/jwt.interceptor';

// import { FileSelectModule } from '@progress/kendo-angular-upload';
import { NgScrollbarModule, NG_SCROLLBAR_OPTIONS } from 'ngx-scrollbar';
import { ToastrModule } from 'ngx-toastr';
import { GlobalErrorHandler } from './helpers/global-error-handler';
import { AppRouteChangeService } from './services/app-route-change.service';
import { RouterModule } from '@angular/router';
import { SortingPipe } from './main/shared/pipes/sorting.pipe';
import { FileSelectModule, UploadModule } from '@progress/kendo-angular-upload';


@NgModule({
  declarations: [AppComponent,SortingPipe],
  imports: [
    NgScrollbarModule,
    BrowserModule,
    BrowserAnimationsModule,
    DropdownModule,
    RadioButtonModule,
    UploadsModule,
    FormsModule,
    UploadModule,
    FileSelectModule,
    // CalendarModule,
    UploadModule,
    HttpClientModule,
    AppRoutingModule,
    UploadModule,
    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NbDialogModule.forRoot(),
    NbWindowModule.forRoot(),
    NbToastrModule.forRoot(),
    NbChatModule.forRoot({
      messageGoogleMapKey: 'AIzaSyA_wNuCzia92MAmdLRzmqitRGvCF7wCZPY',
     
    }),
    CoreModule.forRoot(),
    ThemeModule.forRoot(),
    ToastrModule.forRoot({
      progressBar: true
    }),
    RouterModule.forRoot(routes, {useHash: true}),
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: SuccessInterceptor, multi: true },
    // { provide: ErrorHandler, useClass: GlobalErrorHandler },
    AppRouteChangeService,
    SortingPipe,
    //ProductsService2
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
